// src/modules/app-views/serviceOrders/pages/Document/components/CardHeaderColumn2.jsx
// *******************************************************************************
// IMPORTS
// *******************************************************************************
import SimpleColumn from 'components/SimpleComponents/SimpleColumn';
import { TeamOutlined } from '@ant-design/icons';
import translateX from 'utils/translateX';
import StatusTag from 'modules/app-views/serviceOrders/components/StatusTag';

// *******************************************************************************
// MAIN COMPONENT
// *******************************************************************************
export const CardHeaderColumn2 = ({
  showCustomer = true,
  showStatus = true,
  ...record
}) => {
  // ─────────────────────────────────────────────────────────────────────────────
  // 3. LOCAL VARIABLES I
  // ─────────────────────────────────────────────────────────────────────────────
  const customerName = record?.customerSnapshot?.name || record?.customerName;
  const status = record?.status;

  // ─────────────────────────────────────────────────────────────────────────────
  // 7. LOCAL VARIABLES II
  // ─────────────────────────────────────────────────────────────────────────────
  const items = [
    {
      key: 'customer',
      icon: <TeamOutlined />,
      label: customerName,
      tooltipText: translateX('customer'),
      tooltipPlacement: 'right',
      hidden: !showCustomer,
    },
    {
      key: 'status',
      icon: null,
      label: status ? <StatusTag status={status} /> : null,
      tooltipText: translateX('status'),
      tooltipPlacement: 'right',
      hidden: !showStatus,
    },
  ];

  // ─────────────────────────────────────────────────────────────────────────────
  // 8. UI
  // ─────────────────────────────────────────────────────────────────────────────
  return <SimpleColumn items={items?.filter(i => i?.label && !i.hidden)} />;
};

// *******************************************************************************
// EXPORT
// *******************************************************************************
export default CardHeaderColumn2;
